<template>
  <BaseDialog centered contentClass="delete-sync-profile-dialog" ref="dialog" :show-actions="true">
    <template slot="title">{{ $t('page.admin-sync-profiles.delete-dialog.title') }}</template>
    <template slot="content">
      <div class="delete-sync-profile-dialog__body">
        <i18n path="page.admin-sync-profiles.delete-dialog.message">
          <template v-slot:name>
            <strong>{{ profile && profile.name }}</strong>
          </template>
        </i18n>
      </div>
      <div class="delete-sync-profile-dialog__actions">
        <FormButton is-outlined @click.native="closeDialog">{{ $t('actions.cancel') }}</FormButton>
        <FormButton is-danger @click.native="onConfirm">{{ $t('actions.delete') }}</FormButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import { mapActions } from 'vuex';

export default {
  name: 'DeleteSyncProfileDialog',
  components: { BaseDialog, FormButton },
  data() {
    return { profile: null };
  },
  methods: {
    ...mapActions('adminSyncProfiles', ['deleteSyncProfile']),
    openDialog(profile) {
      this.profile = profile;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onConfirm() {
      this.deleteSyncProfile(this.profile.id)
        .then(() => {
          this.$toast.success(this.$t('page.admin-sync-profiles.delete-dialog.success'));
          this.$emit('action-succeeded');
          this.closeDialog();
        })
        .catch(() => this.$toast.error(this.$t('page.admin-sync-profiles.delete-dialog.error')));
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-sync-profile-dialog {
  height: auto;
  width: 480px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.delete-sync-profile-dialog {
  &__body {
    font-size: 16px;
    margin-bottom: 24px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
